<template>
  <div>
    <z-centralized-toolbar>
      <!-- <v-toolbar-items> -->
        <v-btn
          id="btn_adicionar"
          class="mr-3"
          depressed
          rounded
          left
          color="primary"
          :to="{ name: 'PedidosAdicionar' }"
        >
          <v-icon left>mdi-cart-plus</v-icon>Novo Pedido
          <v-tooltip bottom activator="#btn_adicionar">Novo Pedido</v-tooltip>
        </v-btn>

        <z-menu-impressoes
          label="Relatórios"
          sublabel="Impressões"
          :itens="impressoes" 
          @abrir:relatorio="abrirRelatorio"
        ></z-menu-impressoes>

        <v-btn
          id="btn_filtrar"
          :depressed="exibir_filtro"
          :text="!exibir_filtro"
          :color="exibir_filtro ? 'primary' : ''"
          rounded
          @click="exibir_filtro = !exibir_filtro"
        >
          <v-icon left>mdi-filter-variant</v-icon>Filtrar
          <v-tooltip bottom activator="#btn_filtrar">Filtro</v-tooltip>
        </v-btn>

        <v-btn
          id="btn_atualizar"
          icon
          :ripple="false"
          :loading="$store.state.loading"
          @click="refresh"
        >
          <v-icon>mdi-refresh</v-icon>
          <v-tooltip bottom activator="#btn_atualizar">Atualizar</v-tooltip>
        </v-btn>
      <!-- </v-toolbar-items> -->

      <!-- <v-spacer></v-spacer> -->

      <z-text-field-search 
        v-model="search" 
        select 
        class="ml-5" 
        @keydown.enter="refresh" 
        @click:clear="limparBusca"
      ></z-text-field-search>
    </z-centralized-toolbar>

    <z-container>
      <v-expand-transition>
        <v-card v-show="exibir_filtro" class="mb-3">
          <v-card-title class="text-subtitle-2">Filtro</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row row dense>
              <v-col sm="6">
                <v-autocomplete
                  v-model="filtro.cliente_id"
                  placeholder=" "
                  label="Cliente"
                  flat
                  clearable
                  filled
                  dense
                  :items="$store.getters['listas/clientes']"
                ></v-autocomplete>
              </v-col>
              <v-col sm="3">
                <v-select
                  v-model="filtro.forma_pagamento"
                  placeholder=" "
                  label="Forma de Pagamento"
                  clearable
                  filled
                  dense
                  :items="$globals.FORMAS_DE_PAGAMENTO"
                ></v-select>
              </v-col>
              <v-col sm="3">
                <v-select
                  v-model="filtro.situacao"
                  placeholder=" "
                  label="Situação"
                  clearable
                  filled
                  dense
                  :items="['Faturado', 'Orçamento', 'Cancelado']"
                ></v-select>
              </v-col>
            </v-row>
            <v-row row dense>
              <v-col sm="3">
                <z-date-picker-menu
                  v-model="filtro.data_inicial"
                  placeholder=" "
                  label="Data Inicial"
                  clearable
                  filled
                  dense
                  hide-details
                  @change="onChangeDataInicial"
                  @click:clear="filtro.data_final = null"
                ></z-date-picker-menu>
              </v-col>
              <v-col sm="3">
                <z-date-picker-menu
                  v-model="filtro.data_final"
                  placeholder=" "
                  label="Data Final"
                  clearable
                  filled
                  dense
                  hide-details
                  @change="onChangeDataFinal"
                  @click:clear="filtro.data_inicial = null"
                ></z-date-picker-menu>
              </v-col>
              <v-col sm="3">
                <v-select
                  v-model="filtro.vendedor_id"
                  placeholder=" "
                  label="Vendedor"
                  clearable
                  filled
                  dense
                  hide-details
                  :items="$store.getters['listas/vendedores']"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="limparFiltros">Cancelar</v-btn>
            <v-btn depressed color="primary" @click="aplicarFiltro">Filtrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-expand-transition>

      <h3 class="text-body-1 mb-3">Pedidos</h3>

      <v-card>

        <v-data-table
          disable-pagination
          id="pedidos"
          item-key="id"
          :options.sync="options"
          :server-items-length="total_de_registros"
          :footer-props="$globals.FOOTER_PROPS"
          :items="pedidos"
          :headers="headers"
          :loading="false"
        >
          <template v-slot:item="{ item: pedido }">
            <tr>
              <td>
                {{ pedido.id }}
                <InfoPedido :pedido="pedido" />
              </td>
              <td>{{ pedido.data | dataBR }}</td>
              <td>{{ pedido.nome }}</td>
              <td>{{ pedido.forma_pagamento }}</td>
              <td class="text-center">
                <v-chip
                  style="font-weight: 400;"
                  small
                  dark
                  :color="corChip(pedido.situacao).color"
                >{{ pedido.situacao }}</v-chip>
              </td>
              <td class="text-right">
                {{ pedido.valor_liquido | valorBR }}

                <!-- <v-list-item>
                  <v-list-item-content class="py-0">
                    <v-list-item-title style="font-size: 14px;">
                      {{ pedido.valor_liquido | valorBR }}
                    </v-list-item-title>
                    <v-list-item-subtitle style="font-size: 12px;" class="font-weight-bold_" :class="corSituacao(pedido.situacao)">
                      {{ pedido.situacao }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item> -->
              </td>
              <!-- <td class="text-right">{{ pedido.valor_restante | valorBR }}</td> -->
              <td class="text-right">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      class="ma-0"
                      :disabled="pedido.situacao == 'Cancelado'"
                      @click="imprimir(pedido)"
                    >
                      <v-icon>print</v-icon>
                    </v-btn>
                  </template>
                  <span>Imprimir Pedido</span>
                </v-tooltip>

                <v-tooltip bottom v-if="!config.PEDIDO_COMO_FATURADO && podeFaturar(pedido)">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      class="ma-0"
                      @click="faturar(pedido)"
                    >
                      <v-icon>monetization_on</v-icon>
                    </v-btn>
                  </template>
                  <span>Faturar Pedido</span>
                </v-tooltip>

                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense>
                    <v-list-item @click="editar(pedido)">
                      <v-list-item-action>
                        <v-icon v-if="podeEditar(pedido)">edit</v-icon>
                        <v-icon v-if="!podeEditar(pedido)">visibility</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>
                        {{ podeEditar(pedido) ? "Editar" : "Visualizar" }}
                        Pedido
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="copiar(pedido)" :disabled="!podeCopiar(pedido)">
                      <v-list-item-action>
                        <v-icon>content_copy</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>Copiar Pedido</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="faturar(pedido)" v-if="config.PEDIDO_COMO_FATURADO && podeFaturar(pedido)">
                      <v-list-item-action>
                        <v-icon>monetization_on</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>Faturar Pedido</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="visualizarFaturamento(pedido)" v-if="podeVisualizarFaturamento(pedido)">
                      <v-list-item-action>
                        <v-icon>monetization_on</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>Visualizar Faturamento</v-list-item-title>
                    </v-list-item>

                    <v-divider v-if="pedido.situacao == 'Orçamento' && $auth.can('pedidos:cancelar')"></v-divider>
                    
                    <v-list-item class="red--text" @click="perguntarExcluir(pedido)" v-if="pedido.situacao == 'Orçamento' && $auth.can('pedidos:cancelar')">
                      <v-list-item-action>
                        <v-icon color="red">delete</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>Cancelar Pedido</v-list-item-title>
                    </v-list-item>

                    <v-divider v-if="['Faturado', 'pdv:venda'].includes(pedido.situacao) && $auth.can('pedidos:estornar')"></v-divider>

                    <v-list-item class="red--text" @click="perguntarEstornar(pedido)" v-if="['Faturado', 'pdv:venda'].includes(pedido.situacao) && $auth.can('pedidos:estornar')" >
                      <v-list-item-action>
                        <v-icon color="red">money_off</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>Estornar Pedido</v-list-item-title>
                    </v-list-item>
                  </v-list>

                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>

      </v-card>
    </z-container>

    <z-dialogo-sim-nao
      ref="dialogoExcluir"
      titulo="Cancelar pedido?"
      botaoSim="Confirmar"
      botaoNao="Dispensar"
      :dividers="true"
      largura="500px"
    >
      O pedido <b>{{ pedido.id }}</b> do cliente <b>{{ pedido.nome }}</b> será
      cancelado e os itens retornarão para o estoque.
    </z-dialogo-sim-nao>

    <faturamento ref="faturamento" @faturado="faturado"></faturamento>

    <z-dialogo-sim-nao
      ref="dialogoEstornar"
      titulo="Estornar pedido?"
      botaoSim="Estornar"
      botaoNao="Cancelar"
      largura="500px"
    >
      Todas faturas lançadas para o pedido <b>{{ pedido.id }}</b> do cliente
      <b>{{ pedido.nome }}</b> serão removidas. O pedido voltará a ser um
      Orçamento.<br />
    </z-dialogo-sim-nao>

    <z-dialogo-sim-nao
      ref="dialogoImpressaoTerminca"
      titulo="Imprimir na impressora térmica?"
      botaoSim="Impressora Térmica"
      botaoNao="Impressora Padrão"
      largura="500px"
    >
      A impressora térmica está habilitada no sistema. Deseja imprimir na impressora térmica?
    </z-dialogo-sim-nao>

    <pedidos-diario ref="dialogoVendasDiario" @imprimir="imprimirVendasDiario" :loading="loading"></pedidos-diario>

    <z-dialogo-impressao 
      ref="dialogoImpressao" 
      titulo="Impressão"
      :url-impressao="urlImpressao"
      @fechar="urlImpressao = ''"
    ></z-dialogo-impressao>
    
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import Faturamento from "./Faturamento";
import config from "@/app/config";
import PedidosDiario from './PedidosDiario';
import { abrirJanela } from '@/app/helpers/utils';
import InfoPedido from "./InfoPedido.vue";

export default {
  name: "pedidos-lista",

  components: {
    Faturamento,
    PedidosDiario,
    InfoPedido
  },

  inject: ["$imprimir"],

  data() {
    return {
      headers: [
        { text: "Pedido", value: "id", width: "100px" },
        { text: "Data", value: "data", width: "100px" },
        { text: "Cliente", value: "nome" },
        { text: "Forma Pagamento", value: "forma_pagamento", width: "150px" },
        { text: "Situação", value: "situacao", width: "10px" },
        { text: "Valor", value: "valor_liquido", align: "right", width: "130px", },
        // { text: "Restante", value: "valor_restante", align: "right", width: "0px", hidden: true},
        { text: "Opções", value: "opcoes", width: "180px", align: "center", sortable: false, },
      ],
      data: this.hoje(),
      pagination: {},
      totalItens: 0,
      excluindo: false,
      estornando: false,
      pedido: {
        cliente: {
          razao: "",
        },
      },
      sheet: false,
      exibir_filtro: false,
      exibir_pesquisa: false,
      // filtro: {
      //   cliente_id: null,
      //   forma_pagamento: null,
      //   situacao: null,
      //   data_inicial: null,
      //   data_final: null,
      //   vendedor_id: null
      // },
      impressoes: [
        { texto: 'Vendas do Dia', acao: this.abrirRelatorioVendasDia, visible: true },
        { texto: 'Caixa Mensal', acao: 'caixa_mensal', visible: false },
        { texto: 'Caixa Período', acao: 'caixa_periodo', visible: false },
        { texto: 'Relatório Gerencial', acao: 'relatorio_gerencial', visible: this.$auth.isAdmin() },
        { texto: 'Impressao Vendas PDF', acao: this.abrirImpressao, visible: this.$auth.isAdmin() },
      ],
      loading: false,
      urlImpressao: '',
      // displayedColumns: [],
    };
  },

  computed: {
    ...mapState("pedidos", [
      "pedidos",
      "paginacao",
      "total_de_registros",
      "filtro",
    ]),
    ...mapGetters("pedidos", ["total_lista_pedidos"]),

    breakpoint() {
      return this.$vuetify.breakpoint;
    },

    listagem: {
      get() {
        return this.$store.state.pedidos.parametros.listagem;
      },
      set(value) {
        this.set_listagem(value);
      },
    },

    search: {
      get() {
        return this.$store.state.pedidos.search;
      },
      set(search) {
        this.$store.commit("pedidos/SET_SEARCH", search);
      },
    },

    options: {
      get() {
        return this.$store.state.pedidos.pagination;
      },
      set(options) {
        this.$store.commit("pedidos/UPDATE_PAGINATION", options);
      },
    },

    mandatory() {
      return this.search ? false : true;
    },

    config() {
      return this.$store.state.configuracoes;
    },
  },
  
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     if (vm.$store.state.pedidos.atualizar) {

  //       if (from.name == 'PedidosAdicionar' || from.name == 'PedidosCopiar') {
  //         vm.listagem = 'hoje';
  //         vm.$router.push({query: {lista: vm.listagem}});
  //         vm.search = null;
  //         vm.page = 1;
  //         vm.refresh().then(response => {
  //           vm.$store.commit('pedidos/set_novo');
  //         });
  //         return;
  //       }

  //     }

  //     vm.$router.push({query: {lista: vm.listagem}});

  //     if (vm.total_lista_pedidos == 0)
  //       vm.refresh();

  //   })
  // },

  beforeMount() {
    // this.$store.dispatch("carregarConfiguracoes");
    this.$store.dispatch("listas/clientes");
    this.$store.dispatch("listas/vendedores");

    if (window.innerWidth <= 1366) {
      this.$store.state.drawer = false;
    }
  },

  mounted() {
    this.setTitulo("Pedidos de Venda");
    this.refresh();
    // this.displayedColumns = this.headers; // Mostra todas as colunas
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapMutations("pedidos", [
      "set_listagem",
      "set_page",
      "set_search",
      "SET_FILTRAR",
      "LIMPAR_FILTRO",
    ]),
    ...mapActions("pedidos", ["listar", "excluir", "abrir", "copiarPedido"]),

    // updateColumns() {
    //   const fields = [
    //     "id",
    //     "data",
    //     "nome",
    //     "forma_pagamento",
    //     "situacao",
    //     "valor_liquido",
    //     // "valor_restante",
    //     "opcoes",
    //   ]

    //   // Define quais colunas exibir com base no tamanho da tela
    //   if (this.$vuetify.breakpoint.mdAndDown) {
    //     this.displayedColumns = this.headers.filter(col => fields.includes(col.value)); // Oculta "Address"
    //   } else {
    //     this.displayedColumns = this.headers; // Mostra todas as colunas
    //   }
    // },

    async refresh() {
      try {
        await this.listar();
      } catch (error) {
        this.$eventbus.erro(
          "Não foi possível obter a lista de pedidos.",
          error
        );
        this.LOADING_OFF();
      }
    },
    aplicarFiltro() {
      this.SET_FILTRAR(true);
      this.listar();
    },

    limparFiltros() {
      this.SET_FILTRAR(false);
      this.LIMPAR_FILTRO();
      this.exibir_filtro = false;
      this.refresh();
    },

    async editar(pedido) {
      try {
        await this.abrir(pedido.id);
        this.$router.push({ name: "PedidosEditar", params: { id: pedido.id } });
      } catch (error) {
        this.$eventbus.erro("Não foi possível abrir este pedido.", error);
        this.LOADING_OFF();
      }
    },

    async copiar(pedido) {
      try {
        await this.copiarPedido(pedido.id);
        this.$router.push({
          name: "PedidosEditar",
          params: { id: this.$store.state.pedidos.pedido.id },
        });
      } catch (error) {
        this.$eventbus.erro("Não foi possível copiar este pedido.", error);
        this.LOADING_OFF();
      }
    },

    mudarLista() {
      this.search = null;
      this.page = 1;

      this.$router.push({ query: { lista: this.listagem } });
      this.refresh();
    },

    buscar() {
      this.page = 1;
      // this.$router.push({query: {lista: 'todos'}});
      // this.listagem = 'todos';
      this.refresh();
    },

    limparBusca() {
      this.search = null;
      this.refresh();
    },

    faturar(pedido) {
      this.$refs.faturamento.abrirFaturamento(pedido);
    },

    visualizarFaturamento(pedido) {
      this.$refs.faturamento.visualizarFaturamento(pedido);
    },

    perguntarExcluir(pedido) {
      this.pedido = pedido;
      // this.$refs.dialogoExcluir.abrir();
      this.$refs.dialogoExcluir.abrir().then(async (response) => {
        if (response == true) await this.confirmarExcluir();
      });
    },

    async confirmarExcluir() {
      try {
        this.$refs.dialogoExcluir.startLoading();
        this.excluindo = true;
        await this.excluir(this.pedido.id);
        this.$eventbus.notificar("Pedido cancelado com sucesso!");
        this.$refs.dialogoExcluir.fechar();
      } catch (error) {
        this.$eventbus.erro("Não foi possível cancelar o pedido.", error);
      } finally {
        this.excluindo = false;
        this.$refs.dialogoExcluir.stopLoading();
      }
    },

    perguntarEstornar(pedido) {
      this.pedido = pedido;
      // this.$refs.dialogoEstornar.abrir()
      this.$refs.dialogoEstornar.abrir().then(async (response) => {
        if (response == true) await this.confirmarEstornar();
      });
    },

    async confirmarEstornar() {
      try {
        this.estornando = true;
        await this.$store.dispatch("pedidos/estornar", this.pedido.id);
        this.pedido.situacao = "Orçamento";
        this.$eventbus.notificar("Pedido estornado.");
      } catch (error) {
        this.$eventbus.erro("Não foi possível estonar pedido.", error);
      } finally {
        this.estornando = false;
        this.$refs.dialogoEstornar.fechar();
      }
    },

    onChangeDataInicial() {
      if (!this.filtro.data_final)
        this.filtro.data_final = this.filtro.data_inicial;
    },

    onChangeDataFinal() {
      if (!this.filtro.data_inicial)
        this.filtro.data_inicial = this.filtro.data_final;
    },

    corChip(situacao) {
      const chips_config = {
        "Orçamento": { color: "blue", text: "blue--text" },
        "Pedido": { color: "red", text: "red--text" },
        "Cancelado": { color: "red", text: "red--text" },
        "Faturado": { color: "green", text: "green--text" },
        // "pdv:venda": { color: "teal", text: "green--text" },
      };

      let item = chips_config[situacao];

      if (!item) {
        return { color: "grey", text: "grey--text" };
      }

      return chips_config[situacao];

    },

    corSituacao(situacao) {
      switch (situacao) {
        case "Orçamento":
          return "blue--text";
          break;

        case "Pedido":
          return "red--text";
          break;

        case "Cancelado":
          return "red--text";
          break;

        case "Faturado":
          return "green--text";
          break;

        default:
          break;
      }
    },

    podeEditar(pedido) {
      return pedido.situacao == "Orçamento";
    },

    podeCopiar(pedido) {
      return pedido.valor_liquido > 0;
    },

    podeFaturar(pedido) {
      return pedido.situacao == "Orçamento" && pedido.valor_liquido > 0;
    },

    podeVisualizarFaturamento(pedido) {
      return ['Faturado', 'pdv:venda'].includes(pedido.situacao);
    },

    faturado(pedido) {
      let pedido_ = this.pedidos.find((p) => p.id == pedido.id);
      pedido_.situacao = "Faturado";
    },

    async imprimir(pedido) {

      const impressao_termica = await this.imprimirNaImpressoraTermica();

      if (impressao_termica) {
        this.$store.dispatch("pedidos/impressaoTermica", pedido.id);
      } else {
        this.$imprimir("/pedidos/" + pedido.id + "/imprimir", "Pedido_" + pedido.id + ".pdf");
      }
    },

    paginar() {},

    teste() {
      this.listagem = null;
    },

    abrirRelatorio(relatorio) {

      console.log(relatorio);

      // if (relatorio === 'caixa_diario') {
      //   // this.imprimirVendasDiario();
      //   this.$refs.dialogoVendasDiario.abrir();
      // }

      // if (relatorio === 'caixa_mensal') {
      //   this.$refs.dialogoMesesAnos.abrir();
      // }

      // if (relatorio === 'relatorio_gerencial') {
      //   this.imprimirCaixaGerencial();
      // }

      // if (relatorio === 'caixa_periodo') {
      //   this.$refs.dialogoIntervaloData.abrir();
      // }
    },

    async imprimirVendasDiario(filtro) {

      const impressao_termica = await this.imprimirNaImpressoraTermica();

      if (impressao_termica) {
        try {
          this.loading = true;
          await this.$store.dispatch("pedidos/vendasdiarias", filtro);
          this.$refs.dialogoVendasDiario.fechar();
        } catch (error) {
          this.$eventbus.erro("Não foi possível imprimir o relatório.", error); 
        } finally {
          this.loading = false;
        }
      } else {
        // this.abrirJanela(window.location.origin + '/pedidos/'+ pedido.id +'/imprimir');
        // this.abrirJanela(config.BASE_URL_PRINT + "/pedidos/" + pedido.id + "/imprimir");
        const print_url = config.IS_PRODUCTION ? window.location.origin : config.BASE_URL_PRINT;
  
        filtro = {
          data_inicial: filtro.data,
          data_final: filtro.data,
          vendedor_id: filtro.vendedor_id || '',
          terminal: filtro.terminal || ''
        }
        this.$imprimir(`relatorios/vendas?` + new URLSearchParams(filtro).toString(), "Vendas_do_dia.pdf");
        // abrirJanela(`${print_url}/caixa/imprimir?` + new URLSearchParams(filtro).toString());

        // this.$imprimir(`caixa/imprimir?` + new URLSearchParams(filtro).toString(), "Vendas_do_dia.pdf");

      }

    },

    abrirImpressao() {
      this.abrirImpressao2('http://etcrm.test/pedidos/77425/imprimir');

      // const print_url = config.IS_PRODUCTION ? window.location.origin : config.BASE_URL_PRINT;

      // const filtro = {
      //   data_inicial: "2024-08-16",
      //   data_final: "2024-08-16",
      //   vendedor_id: 1,
      //   terminal: "011"
      // }

      // const urlImpressao = `${print_url}/relatorios/vendas-mini?` + new URLSearchParams(filtro).toString();
      // // this.$refs.dialogoImpressao.abrir();
      // setTimeout(async () => {
      //   await this.loadPDF(urlImpressao);
      //   this.$refs.dialogoImpressao.abrir();
      //   // this.urlImpressao = `${print_url}/relatorios/contaspagarparceiros/imprimir?` + new URLSearchParams(this.filtro).toString();
      // }, 300);
    },

    async abrirImpressao2(url) {
      const response = await this.$axios.get(url, { responseType: 'blob' }).then(response => response.data);
      const pdfBlob = new Blob([response], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      this.urlImpressao = pdfUrl;
      this.$refs.dialogoImpressao.abrir();

      // window.open(pdfUrl, "_blank");
    },

    async loadPDF(url) {
      const pdf = await this.$axios.get(url, { responseType: 'blob' }).then(response => response.data);

      window.open(this.gerarBlobImpressao(pdf), "_blank");
      this.urlImpressao = this.gerarBlobImpressao(pdf);
    },

    gerarBlobImpressao(pdf) {
      return window.URL.createObjectURL(new Blob([pdf], {
        type: 'application/pdf'
      }));
    },

    abrirRelatorioVendasDia() {
      this.$refs.dialogoVendasDiario.abrir();
    },

    async imprimirNaImpressoraTermica() {
      let response = false;
      if (this.config.APP_IMPRESSAO_TERMICA) {
        response = await this.$refs.dialogoImpressaoTerminca.abrir();
      }

      this.$refs.dialogoImpressaoTerminca.fechar();
      return this.config.APP_IMPRESSAO_TERMICA && response === true;
    },
  },

  watch: {
    options: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
    // '$vuetify.breakpoint.name': 'updateColumns', // Monitora mudanças no tamanho da tela
  },
};
</script>

<style scoped>

</style>
